import { render, staticRenderFns } from "./select-box.vue?vue&type=template&id=594c9de1&scoped=true&"
import script from "./select-box.vue?vue&type=script&lang=js&"
export * from "./select-box.vue?vue&type=script&lang=js&"
import style0 from "./select-box.vue?vue&type=style&index=0&id=594c9de1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c9de1",
  null
  
)

export default component.exports